import axiosInstance from "services/AxiosInstance";
import { TFeatureFlagListResponse } from "types";

export const getFeatureFlagsService = async (): Promise<TFeatureFlagListResponse> => {
  const response = await axiosInstance.get("featureflags");
  return response.data;
};
